import Image from "next/image";
import OAuthLoginButton from "./OAuthLoginButton";

export default function MicrosoftLoginButton({
  size
}: {
  size?: "md" | "lg";
}) {
  const iconSize = size === "lg" ? 26 : 21;
  return (
    <OAuthLoginButton
      provider="microsoft"
      icon={
        <Image
          src="/microsoft_logo.png"
          alt="Microsoft"
          width={iconSize}
          height={iconSize}
        />
      }
      label="Doorgaan met Microsoft"
      size={size}
    />
  );
}
